const FAVOURITE_IMG_KEY = 'favouriteImg';
const SELECTED_FAVOURITE_KEY = 'selectedFavourite';

export function saveSelectedFavourite(item) {
  if (!item?.imageUrl) return;
  try {
    localStorage.setItem(FAVOURITE_IMG_KEY, String(item.imageUrl));
    localStorage.setItem(SELECTED_FAVOURITE_KEY, JSON.stringify(item));
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new Event('favouriteImgUpdated'));
  } catch {
    /* ignore */
  }
}

export function clearSelectedFavourite() {
  try {
    localStorage.removeItem(FAVOURITE_IMG_KEY);
    localStorage.removeItem(SELECTED_FAVOURITE_KEY);
  } catch {
    /* ignore */
  }
}

export function getSelectedFavourite() {
  try {
    const raw = localStorage.getItem(SELECTED_FAVOURITE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Raw favourite image URL for merch generate / previews. */
export function getSelectedFavouriteImageUrl() {
  const selected = getSelectedFavourite();
  const fromItem = String(
    selected?.imageUrl ||
      selected?.image_url ||
      selected?.imgURL ||
      selected?.picture ||
      selected?.url ||
      selected?.image ||
      ''
  ).trim();
  if (fromItem) return fromItem;
  try {
    return String(localStorage.getItem(FAVOURITE_IMG_KEY) || '').trim();
  } catch {
    return '';
  }
}

/** Favourite station / type label (e.g. "Snap & Print", "caricature portrait"). */
export function getSelectedFavouriteType() {
  const selected = getSelectedFavourite();
  return String(
    selected?.type ||
      selected?.name ||
      selected?.station ||
      selected?.category ||
      ''
  ).trim();
}
